// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6705cfa7","732":"04096e27","977":"5f73adec"}[chunkId] + ".chunk.js";
};